import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Modal from 'reactstrap/es/Modal';
import ExpenseForm from './ExpensePaymentForm';
import TenantActions from '../../../../store/actions/tenant';
import { RTLProps, ThemeProps } from '../../../../shared/prop-types/ReducerProps';

class ExpenseModal extends React.PureComponent {
  static propTypes = {
    updating: PropTypes.bool.isRequired,
    createExpensePaymentRequest: PropTypes.func.isRequired,
    updateExpensePaymentRequest: PropTypes.func.isRequired,
    editExpensePayment: PropTypes.func.isRequired,
    editingExpense: PropTypes.shape({
      _id: PropTypes.string.isRequired,
    }),
    theme: ThemeProps.isRequired,
    rtl: RTLProps.isRequired,
  };

  static defaultProps = {
    editingExpense: null,
  };

  handleSubmit = (data) => {
    const payload = { };
    const { createExpensePaymentRequest, updateExpensePaymentRequest, editingExpense } = this.props;
    ['projectId', 'currency']
      .forEach((key) => {
        if (data[key] && typeof data[key] === 'object') {
          payload[key] = data[key].value;
        }
      });
    ['amount', 'appliedDate', 'description']
      .forEach((key) => {
        payload[key] = data[key];
      });

    if (payload.description) {
      payload.title = payload.description;
      if (payload.title.length > 40) {
        payload.title = `${payload.title.substr(0, 36)} ...`;
      }
    }

    if (editingExpense._id === 'new') {
      createExpensePaymentRequest(payload);
    } else {
      payload._id = editingExpense._id;
      updateExpensePaymentRequest(payload);
    }
  };

  render() {
    const {
      updating, editingExpense, theme, rtl, editExpensePayment,
    } = this.props;

    const modalClasses = classNames(
      {
        'todo__add-modal': true,
      },
      theme.className,
      `${rtl.direction}-support`,
    );

    return (
      <Modal
        isOpen={!!editingExpense}
        toggle={() => editExpensePayment(null)}
        className={modalClasses}
      >
        {editingExpense && (
          <ExpenseForm
            loading={updating}
            onSubmit={this.handleSubmit}
            close={() => editExpensePayment(null)}
            initialValues={editingExpense}
            isNew={editingExpense._id === 'new'}
          />
        )}
      </Modal>
    );
  }
}


const mapStateToProps = state => ({
  updating: state.expensePayments.updating,
  editingExpense: state.expensePayments.editingExpensePayment,
  theme: state.theme,
  rtl: state.rtl,
});

const mapDispatchToProps = {
  createExpensePaymentRequest: TenantActions.ExpensePayments.createExpensePaymentRequest,
  updateExpensePaymentRequest: TenantActions.ExpensePayments.updateExpensePaymentRequest,
  editExpensePayment: TenantActions.ExpensePayments.editExpensePayment,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExpenseModal);
